import "./Header.scss"
import React, { useState } from "react"
import { i18n } from "@lingui/core"
import { HStack } from "./layout"
import { useFider } from "@fider/hooks"
import { NotificationIndicator, UserMenu, Icon, SignInModal, RSSModal } from "@fider/components"
import { Trans } from "@lingui/react/macro"
import IconRss from "@fider/assets/images/heroicons-rss.svg"
import logoSvg from '../assets/images/naviair-logo.svg';

interface HeaderProps {
  hasInert?: boolean
}

export const Header = (props: HeaderProps) => {
  const fider = useFider();
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)
  const [isRSSModalOpen, setIsRSSModalOpen] = useState(false)

  const showSignInModal = (e: React.MouseEvent) => {
    e.preventDefault()
    setIsSignInModalOpen(true)
  }

  const showRSSModal = (e: React.MouseEvent) => {
    e.preventDefault()
    setIsRSSModalOpen(true)
  }

  const atomFeedTitle = i18n._({ id: "action.postsfeed", message: "Posts Feed" })
  const hideSignInModal = () => setIsSignInModalOpen(false)
  const hideRSSModal = () => setIsRSSModalOpen(false)

  return (
    <>
      <div className="success-wall-container">
        <div id="c-header" {...(props.hasInert && { inert: "true" })}>
          <SignInModal isOpen={isSignInModalOpen} onClose={hideSignInModal} />
          <RSSModal isOpen={isRSSModalOpen} onClose={hideRSSModal} url={`${fider.settings.baseURL}/feed/global.atom`} />
          <HStack className="p-4 w-full">
            <div className="container">
              <HStack justify="between">
                <div className="flex flex-x flex-items-center flex--spacing-2 h-8" />
                {fider.session.isAuthenticated && (
                  <HStack spacing={2}>
                    {fider.session.tenant.isFeedEnabled && (
                      <button title={atomFeedTitle} className="c-themeswitcher" onClick={showRSSModal}>
                        <Icon sprite={IconRss} className="h-6 text-gray-500" />
                      </button>
                    )}
                    {/*<ThemeSwitcher />*/}
                    <NotificationIndicator />
                    <UserMenu />
                  </HStack>
                )}
                {!fider.session.isAuthenticated && (
                  <HStack spacing={2}>
                    {fider.session.tenant.isFeedEnabled && (
                      <button title={atomFeedTitle} className="c-themeswitcher" onClick={showRSSModal}>
                        <Icon sprite={IconRss} className="h-6 text-gray-500" />
                      </button>
                    )}
                    {/*<ThemeSwitcher />*/}
                    <a href="#" className="uppercase text-sm" onClick={showSignInModal}>
                      <Trans id="action.signin">Sign in</Trans>
                    </a>
                  </HStack>
                )}
              </HStack>
            </div>
          </HStack>
        </div>
        <a href={'/'}>
          <div className="success-wall-header">
            <div className="background-animation"></div>
            <div className="emoji-row">
              🎯 ⭐ 🚀 💡 🏆
            </div>
            <Icon sprite={logoSvg} className="h-4" />
            <h1 className="main-title">T´s Succesvæg</h1>
            <div className="accent-line" />
            <p className="subtitle">
              Del det, du stolt af · Fejr de gode historier · Vi lykkes sammen
            </p>
          </div>
        </a>
      </div>
    </>
  )
}
